import React from 'react';
import {connect} from 'react-redux';

// Actions
import {Warning} from '@material-ui/icons';
import {T} from 'Actions/translate';
import {USER_ROLE} from 'Utils/constant';
import BasicButton from 'Components/common/BasicButton';
import copy from 'copy-to-clipboard';
import {openNotification} from 'Actions/notification';

class OrderShipToDetail extends React.Component {
    shippingTypeList = {1: T('order_self_pick_up'), 2: T('order_delivery_a')};

    copyToClipBoard = () => {
        const {receiverAddress, receiver, receiverTel} = this.props.data;
        copy(`${receiver} (${receiverTel}) ${receiverAddress} `);
        this.props.openNotification(T('notification_copy_success'), 'success');
    };
    render() {
        const {data, localData} = this.props;

        return (
            <div
                className={`order-ship-to-detail-container ${
                    this.props.className ? this.props.className : ''
                }`}>
                <h4 className="order-ship-to-detail-title">
                    {T('order_ship_info')}
                    {localData.roleType === USER_ROLE.HOST && (
                        <BasicButton
                            className="copy-red"
                            onClickOfSingleTap={this.copyToClipBoard}
                            isStopPropagation={true}>
                            {T('copyall_btn_label')}
                        </BasicButton>
                    )}
                </h4>
                <div className="row mb-4">
                    <div className="ship-to-name text-ellipsis">
                        <label>{T('order_consignee')}</label> {data.receiver}
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="ship-to-tel text-ellipsis">
                        <label>{T('order_contact')}</label>{' '}
                        <a
                            className="shipment-list-shippment_contact"
                            href={`tel:${data.receiverTel}`}>
                            {data.receiverTel}
                        </a>
                    </div>
                </div>
                {localData.roleType === 3 ? (
                    <React.Fragment>
                        <div className="ship-to-num row mb-4">
                            <label>{T('order_ship_to_number')}</label>{' '}
                            <span className="value">{data.shipToNum}</span>
                        </div>
                    </React.Fragment>
                ) : null}
                {localData.roleType !== USER_ROLE.HOST ? (
                    <div className="row lab-dept mb-4">
                        <label className="lab-dept-label">
                            {T('order_subject')}
                        </label>
                        <span className="lab-dept-value">{data.labOrDept}</span>
                    </div>
                ) : null}

                <div
                    className={`row address ${
                        localData.roleType === USER_ROLE.HOST
                            ? ' mb-4'
                            : ' mb-14'
                    }`}>
                    <label className="address-label">
                        {T('order_address')}
                    </label>
                    <span className="address-value">
                        {data.receiverAddress}
                    </span>
                </div>

                {localData.roleType === USER_ROLE.HOST ? (
                    <div className="row lab-dept mb-14">
                        <label className="lab-dept-label">
                            {T('order_subject')}
                        </label>
                        <span className="lab-dept-value">{data.labOrDept}</span>
                    </div>
                ) : null}
                {data.orderType === 'TFS' ? null : (
                    <React.Fragment>
                        {/* <p className="delivery-method text-ellipsis">
                            {T('order_delivery_method_colon')}{' '}
                            <span>
                                {this.shippingTypeList[data.shippingType]}
                            </span>
                        </p>
                        <div className="warning-text row mb-14">
                            <i className="warning-icon">
                                <Warning className="icon" />
                            </i>
                            {data.shippingType === 1 ? (
                                <div>{T('order_self_take')}</div>
                            ) : (
                                <div>{T('order_stock_delivery_message')}</div>
                            )}
                        </div> */}
                        {data.shippingType === 1 ? (
                            <React.Fragment>
                                <div className="row mb-4">
                                    <div className="host-name text-ellipsis">
                                        <label>{T('order_host')}</label>{' '}
                                        {data.hostName}
                                    </div>
                                    <div className="host-tel text-ellipsis">
                                        <label>{T('order_contact')}</label>{' '}
                                        <a href={`tel:${data.hostMobile}`}>
                                            {data.hostMobile}
                                        </a>
                                    </div>
                                </div>
                                <div className="row address">
                                    <label className="sc-address-label">
                                        {T('order_address')}
                                    </label>
                                    <span className="sc-address-value">
                                        {data.scAddress}
                                    </span>
                                </div>
                            </React.Fragment>
                        ) : null}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData} = state;

    return {
        localData,
    };
};

const mapDispatchToProps = {
    openNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderShipToDetail);
